const Config = {
  ClientColor: "#003366",
  ProviderColor: "#F44336",
};

export default Config;
